/** Parses a URL query param that may be string ('true'/'false') or boolean. Returns the boolean, or undefined if invalid. Case-insensitive for strings. */
function parseBooleanUrlParam(value) {
    switch (String(value).toLowerCase()) {
        case 'true': return true;
        case 'false': return false;
        default: return undefined;
    }
}

/** Returns parsed use_max_points from location.search, or undefined if not present/invalid. */
function getUseMaxPointsFromLocation(location) {
    const search = location && location.search;
    if (!search) return undefined;
    const urlParam = new URLSearchParams(search).get('use_max_points');
    return parseBooleanUrlParam(urlParam);
}

module.exports = {
    parseBooleanUrlParam,
    getUseMaxPointsFromLocation,
};
